import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterCBondsCadastroBondsAciTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "IDEmissao": null,
            "DataEvento": dayjs().format(DATE_FORMAT),
            "ISIN": null,
            "JurosAccruados": null,
            "PrecoNominalCirculacao": null,
            "TaxaCupomAtual": null,
            "MultiploIntegralCirculacao": null,
            "DataAtualizacaoOrigem": null,
            "IDRegiaoPaisEmitente": null,
            "IDPaisEmitente": null,
            "IDEmitente": null,
            "TipoEmitente": null,
            "JurosAccruadosCompleto": null,
            "JurosAccruadosEurobondNominal": null,
            "MercadoNegocociacao": null,
            "IDTipo": null
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, IDEmissao, DataEvento, ISIN, JurosAccruados, PrecoNominalCirculacao, TaxaCupomAtual, MultiploIntegralCirculacao, DataAtualizacaoOrigem, IDRegiaoPaisEmitente, IDPaisEmitente, IDEmitente, TipoEmitente,JurosAccruadosCompleto, JurosAccruadosEurobondNominal, MercadoNegocociacao, IDTipo
            } = newRow

        const body = {
            "IDEmissao": IDEmissao,
            "DataEvento": DataEvento,
            "ISIN": ISIN,
            "JurosAccruados": JurosAccruados,
            "PrecoNominalCirculacao": PrecoNominalCirculacao,
            "TaxaCupomAtual": TaxaCupomAtual,
            "MultiploIntegralCirculacao": MultiploIntegralCirculacao,
            "DataAtualizacaoOrigem": DataAtualizacaoOrigem,
            "IDRegiaoPaisEmitente": IDRegiaoPaisEmitente,
            "IDPaisEmitente": IDPaisEmitente,
            "IDEmitente": IDEmitente,
            "TipoEmitente": TipoEmitente,
            "JurosAccruadosCompleto": JurosAccruadosCompleto,
            "JurosAccruadosEurobondNominal": JurosAccruadosEurobondNominal,
            "MercadoNegocociacao": MercadoNegocociacao,
            "IDTipo": IDTipo
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataEvento',
            headerName: 'DataEvento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            },
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'JurosAccruados',
            headerName: 'JurosAccruados',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoNominalCirculacao',
            headerName: 'PrecoNominalCirculacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TaxaCupomAtual',
            headerName: 'TaxaCupomAtual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MultiploIntegralCirculacao',
            headerName: 'MultiploIntegralCirculacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataAtualizacaoOrigem',
            headerName: 'DataAtualizacaoOrigem',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDRegiaoPaisEmitente',
            headerName: 'IDRegiaoPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDPaisEmitente',
            headerName: 'IDPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDEmitente',
            headerName: 'IDEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TipoEmitente',
            headerName: 'TipoEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'JurosAccruadosCompleto',
            headerName: 'JurosAccruadosCompleto',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'JurosAccruadosEurobondNominal',
            headerName: 'JurosAccruadosEurobondNominal',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'MercadoNegocociacao',
            headerName: 'MercadoNegocociacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDTipo',
            headerName: 'IDTipo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterCBondsCadastroBondsAciTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterCBondsCadastroBondsAciTable